import { AlienationActiveSolutionDto } from 'lib_api/lib/api/gen';

import { NavbarItem } from 'components/NavBar/types';
import { useEnvironnement } from 'hooks/EnvironementStoreContext';
import { profileEnumMapping } from 'utils/enumData';

const getImportRoute = (path: string) => {
  return {
    label: 'Import refus / impossibilités de vente',
    link: `${path}/domaine/import`,
  };
};

export const faqViewPath = `${profileEnumMapping['ADMIN_FONCTIONNEL'].homePath}/referentiels/dashboard/faq/view`;

export const faqDomainPath = `${profileEnumMapping['ADMIN_FONCTIONNEL'].homePath}/referentiels/dashboard/faq-domaine`;

export const faqPath = `${profileEnumMapping['ADMIN_FONCTIONNEL'].homePath}/referentiels/dashboard/faq`;

/**
 * Build import/export route items only if the import/export Alienation bypass solution is enabled
 * @param path default admin path
 * @param activeSolution
 */
const buildRemiseAuDomaineRoutes = (
  path: string,
  activeSolution?: AlienationActiveSolutionDto,
): NavbarItem[] => {
  const availableRoutes = [
    ...(activeSolution?.contournementImportEnabled
      ? [getImportRoute(path)]
      : []),
  ];

  if (availableRoutes.length === 0) {
    return [];
  }

  return [
    {
      label: 'Remise au domaine',
      dropdown: availableRoutes,
    },
  ];
};

export const useAdminNavbarContent = (
  path: string,
  activeSolution?: AlienationActiveSolutionDto,
): NavbarItem[] => {
  const [env] = useEnvironnement();

  return [
    {
      label: 'Tableau de bord',
      link: `${path}`,
    },
    {
      label: 'Suivi du workflow',
      link: `${env.CAMUNDA_URL}${env.CAMUNDA_COCKPIT_PATH}`,
    },
    {
      label: 'Gestion des référentiels',
      dropdown: [
        {
          label: 'Partage de documents spécifiques',
          link: `${path}/referentiels/documents-specifiques`,
        },
        {
          label: 'Export des référentiels',
          link: `${path}/referentiels/export`,
        },
        {
          label: 'Gestion des manuels',
          link: `${path}/referentiels/manuels`,
        },
        {
          label: 'Gestion du modèle de fiche descriptive',
          link: `${path}/referentiels/fiche-descriptive`,
        },
        {
          label: 'Gestion du bandeau information',
          link: `${path}/referentiels/information-message`,
        },
        {
          label: 'Gestion des tutoriels vidéos',
          link: `${path}/referentiels/dashboard/videos`,
        },
        {
          label: 'Gestion des branches',
          link: `${path}/referentiels/dashboard/branche`,
        },
        {
          label: 'Gestion des états',
          link: `${path}/referentiels/dashboard/etat`,
        },
        {
          label: 'Gestion des genres simplifiés',
          link: `${path}/referentiels/dashboard/genre-simplifie`,
        },
        {
          label: "Gestion des unités des forces de l'ordre",
          link: `${path}/referentiels/dashboard/unite-fo`,
        },
        {
          label: 'Gestion des fourrières',
          link: `${path}/referentiels/dashboard/fourriere`,
        },
        ...(env.JUSTICE_ACTIVE_BOOL
          ? [
              {
                label: 'Gestion des juridictions',
                link: `${path}/referentiels/dashboard/juridiction`,
              },
            ]
          : []),
        {
          label: 'Gestion des autorités de fourrière',
          link: `${path}/referentiels/dashboard/autorite-fourriere`,
        },
        {
          label: "Gestion des types d'autorité de fourrière",
          link: `${path}/referentiels/dashboard/type-autorite-fourriere`,
        },
        {
          label: 'Gestion des liens du pied de page',
          link: `${path}/referentiels/dashboard/lien-pied-de-page`,
        },
        {
          label: 'Gestion des marques',
          link: `${path}/referentiels/dashboard/marque`,
        },
        {
          label: 'Gestion des motifs de MEF',
          link: `${path}/referentiels/dashboard/motif-mef`,
        },
        {
          label: 'Gestion des motifs de sortie',
          link: `${path}/referentiels/dashboard/motif-sortie`,
        },
        {
          label: 'Gestion des centres VHU',
          link: `${path}/referentiels/dashboard/centre-VHU`,
        },
        {
          label: 'Gestion de la FAQ',
          link: `${path}/referentiels/dashboard/faq-domaine`,
        },
      ],
    },
    ...buildRemiseAuDomaineRoutes(path, activeSolution),
    {
      label: 'Comptes des utilisateurs',
      dropdown: [
        {
          label: 'Administration',
          link: `${path}/comptes/administration`,
        },
        {
          label: 'Supervision',
          link: `${path}/comptes/supervision`,
        },
      ],
    },
    {
      label: 'Gestion du classement',
      link: `${path}/classement`,
    },
    {
      label: 'Administration avancée',
      link: `${path}/administration-avancee`,
    },
    {
      label: 'Configurations',
      link: `${path}/configurations`,
    },
  ];
};
